<template>
  <div>
    <BlockHeader name="Data Import / File Imports" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
        <div class="col-lg-6 col-sm-12 col-xs-12">
          <Select
            v-model="settingsLocal.importDefaultEncoding"
            :options="ENCODING_OPTIONS"
            form-group-id="Import Default Encoding"
            placeholder="Import Default Encoding"
          />
        </div>
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Select v-model="settingsLocal.xmlEncoding" :options="ENCODING_OPTIONS" form-group-id="XML Encoding" placeholder="XML Encoding" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Select v-model="settingsLocal.csvEncoding" :options="ENCODING_OPTIONS" form-group-id="CSV Encoding" placeholder="CSV Encoding" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.xmlPath" form-group-id="XML Path" placeholder="XML Path" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.csvPath" form-group-id="CSV Path" placeholder="CSV Path" />
      </div>
    </div>

    <!--  -->

    <BlockHeader name="Data Import / MS-SQL" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.mssql_hostname" form-group-id="Hostname" placeholder="Hostname" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.mssql_port" form-group-id="Port" placeholder="Port" />
      </div>
      <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
        <div class="col-lg-6 col-sm-12 col-xs-12">
          <Input v-model="settingsLocal.mssql_database" form-group-id="Database" placeholder="Database" />
        </div>
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.mssql_username" form-group-id="Username" placeholder="Username" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.mssql_password" form-group-id="Password" placeholder="Password" />
      </div>
    </div>

    <!--  -->

    <BlockHeader name="SOAP interface" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.soap_hostname" form-group-id="Hostname" placeholder="Hostname" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.soap_port" form-group-id="Port" placeholder="Port" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.soap_username" form-group-id="Username" placeholder="Username" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.soap_password" form-group-id="Password" placeholder="Password" />
      </div>
    </div>

    <!--  -->

    <BlockHeader name="Data Export Paths" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.exportPathXml" form-group-id="XML-RPTrade Standart" placeholder="XML-RPTrade Standart" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Checkbox
          v-model="settingsLocal.isXmlExportEnabled"
          form-group-id="XML-RPTrade Standart Export Enabled"
          placeholder="XML-RPTrade Standart Export Enabled"
        />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.exportPathXmlSageGsV2" form-group-id="XML-SAGE GS Export V2" placeholder="XML-SAGE GS Export V2" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Checkbox
          v-model="settingsLocal.isXmlSageGsV2ExportEnabled"
          form-group-id="XML-SAGE GS Export V2 Export Enabled"
          placeholder="XML-SAGE GS Export V2 Enabled"
        />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.exportPathSogSoap" form-group-id="SOG SOAP" placeholder="SOG SOAP" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Checkbox v-model="settingsLocal.isSogSoapExportEnabled" form-group-id="SOG SOAP Export Enabled" placeholder="SOG SOAP Export Enabled" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.exportPathCsv" form-group-id="RP CSV" placeholder="RP CSV" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Checkbox v-model="settingsLocal.isCsvExportEnabled" form-group-id="RP CSV Export Enabled" placeholder="RP CSV Export Enabled" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.exportPathMsSql" form-group-id="MS-SQL" placeholder="MS-SQL" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Checkbox v-model="settingsLocal.isMsSqlExportEnabled" form-group-id="MS-SQL Export Enabled" placeholder="MS-SQL Export Enabled" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.exportPathJson" form-group-id="JSON" placeholder="JSON" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Checkbox v-model="settingsLocal.isJsonExportEnabled" form-group-id="JSON Export Enabled" placeholder="JSON Export Enabled" />
      </div>
    </div>

    <!--  -->

    <BlockHeader name="Image Data" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
        <div class="col-lg-6 col-sm-12 col-xs-12">
          <Input v-model="settingsLocal.imagePath" form-group-id="Image Path" placeholder="Image Path" />
        </div>
      </div>
      <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
        <div class="col-lg-6 col-sm-12 col-xs-12">
          <Input
            v-model="settingsLocal.imagePathLowerResolution"
            form-group-id="Image PathLower Resolution"
            placeholder="Image Path (Lower Resolution)"
            :tile-size="9"
          />
        </div>
      </div>
    </div>

    <!--  -->

    <BlockHeader name="Order settings" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
        <div class="col-lg-6 col-sm-12 col-xs-12">
          <Input v-model="settingsLocal.auftragsherkunft" form-group-id="Auftragsherkunft" placeholder="Auftragsherkunft" />
        </div>
      </div>
      <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
        <div class="col-lg-6 col-sm-12 col-xs-12">
          <Input v-model="settingsLocal.vorgabeauftragsnummer" form-group-id="Vorgabeauftragsnummer" placeholder="Vorgabeauftragsnummer" />
        </div>
      </div>
    </div>

    <!--  -->

    <BlockHeader name="Allgemein" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
        <div class="col-lg-6 col-sm-12 col-xs-12">
          <Checkbox
            v-model="settingsLocal.transfer_only_employee_related_customers"
            form-group-id="Kunden nur vertreterbezogen übertragen"
            placeholder="Kunden nur vertreterbezogen übertragen"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '../../../common/input/index';
import Select from '../../../common/select/index';
import Checkbox from '../../../common/checkbox/index';
import BlockHeader from '../../../common/block-header';

import { ENCODING_OPTIONS } from '../../../../../../../../constants';

export default {
  name: 'GeneralSettings',
  components: { Input, BlockHeader, Select, Checkbox },
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      ENCODING_OPTIONS: ENCODING_OPTIONS
    };
  },
  computed: {
    settingsLocal: {
      get: function() {
        return this.settings;
      },
      set: function(value) {
        this.$emit('settings', value);
      }
    }
  }
};
</script>
